<template>
  <skud-card-list />
</template>

<script>
import SkudCardList from '@/views/skud/components/SkudCardList.vue'

export default {
  name: 'ClientSkudCardList',
  components: { SkudCardList }
}
</script>
